import Image from "next/image";
import styles from "./DocumentationSection.module.css";
import Link from "next/link";

export default function DocumentationSection() {
  return (
    <section className={styles.wrapper}>
      {/* Floating Shapes */}
      <div className={styles.shape1}></div>
      <div className={styles.shape2}></div>
      <div className={styles.shape3}></div>

      <div className={styles.container}>
        {/* Illustration */}
        <div className={styles.illustrationWrapper}>
          <div className={styles.animatedIllustration}>
            <Image
              src="/images/others/documentation.png"
              alt="Documentation Illustration"
              width={500}
              height={400}
              className={styles.image}
              priority
            />
          </div>
        </div>

        {/* Text Content */}
        <div className={styles.content}>
          <h2 className={styles.title}>Documentation</h2>
          <p className={styles.description}>
            Explore detailed guides, best practices, and examples to help you
            get started with our platform. Designed with clarity and depth for
            beginners and advanced users alike.
          </p>

          <Link href="/learn-more" className={styles.button}>
            Read Full Documentation →
          </Link>
        </div>
      </div>
    </section>
  );
}
